import { CategoryModel } from "models";
import React from "react";
import { useEffect } from "react";
import { Utils } from "utils";

type PROPS = {
  category: CategoryModel[];
  options: {
    corp_large_category_id?: string;
    corp_medium_category_id?: string;
  };
};

const CategoryCorpForm: React.FC<PROPS> = (props) => {
  const [larges, setLarges] = React.useState<CategoryModel[]>([]);
  const [midiums, setMidiums] = React.useState<CategoryModel[]>([]);

  const [valueL, setValueL] = React.useState("");
  const [valueM, setValueM] = React.useState("");

  useEffect(() => {
    setLarges(props.category);
    const valueL = props.options.corp_large_category_id;
    if (!valueL) {
      setValueL("");
      setValueM("");
    } else {
      const target = Utils.Category.pick(valueL, props.category);
      setMidiums(target?.list ?? []);
      setValueL(valueL);
      const valueM = props.options.corp_medium_category_id;
      if (!valueM) {
        setValueM("");
      } else {
        setValueM(valueM);
      }
    }
  }, [props.category, props.options]);

  return (
    <div className="flex items-center gap-4">
      {/* <div>{JSON.stringify(props.options)}</div> */}
      <div className="flex-1 flex gap-2">
        <select
          className="flex-1"
          value={valueL}
          onChange={(e) => {
            const value = e.target.value;
            setValueL(value);
            if (value === "") {
              delete props.options.corp_large_category_id;
              delete props.options.corp_medium_category_id;
              setValueM("");
              setMidiums([]);
            } else {
              props.options.corp_large_category_id = value;
              delete props.options.corp_medium_category_id;
              setValueM("");
              const target = Utils.Category.pick(value, props.category);
              setMidiums(target?.list ?? []);
            }
          }}
        >
          <option value="">メインカテゴリー選択</option>
          {larges.map((v, i) => {
            return (
              <option key={i} value={v.id}>
                {v.name}
              </option>
            );
          })}
        </select>
        <select
          className={`flex-1 ${valueL !== "" && !!midiums.length ? 'visible' : 'invisible'}`}
          value={valueM}
          onChange={(e) => {
            const value = e.target.value;
            setValueM(value);
            if (value === "") {
              delete props.options.corp_medium_category_id;
            } else {
              props.options.corp_medium_category_id = value;
            }
          }}
          disabled={valueL === ""}
        >
          <option value="">サブカテゴリー選択</option>
          {midiums.map((v, i) => {
            return (
              <option key={i} value={v.id}>
                {v.name}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default CategoryCorpForm;
